import { Component, ReactNode } from 'react';

interface FallbackBoundaryProps {
  fallback: ReactNode;
  children: ReactNode;
}

/** Shows `fallback` in place of a part that failed to render (e.g. a lazy chunk that didn't load), so the page around it stays. */
export default class FallbackBoundary extends Component<FallbackBoundaryProps, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
